'use strict';

import register from './core';
import '../functions/jquery-global.js';

register('search-dropdown', function (element) {
  var $element = $(element),
    $searchInput = $('#search-dropdown-input'),
    $searchButton = $('.search-dropdown__submit'),
    $searchDropdown = $('#search-dropdown'),
    activeClass = 'nav__button--active';

  $element.data('expanded', false);

  $element.on('click', function (event) {
    event.preventDefault();
    var isExpanded = $element.data('expanded');

    if (isExpanded) {
      $searchDropdown.attr('aria-expanded', false).attr('aria-hidden', true).css('height', 0);
      $element.data('expanded', false).removeClass(activeClass).find('use').attr('xlink:href', '#icon-search');
      $searchButton.attr('tabindex', -1);
      $searchInput.attr('tabindex', -1).blur();

    } else {
      $searchDropdown.attr('aria-expanded', true).attr('aria-hidden', false).css('height', ($searchDropdown.find('.container')[0].offsetHeight + 'px'));
      $element.data('expanded', true).addClass(activeClass).find('use').attr('xlink:href', '#icon-close');
      $searchButton.attr('tabindex', 0);
      $searchInput.attr('tabindex', 0).focus();
    }
  });
});
